import { render, staticRenderFns } from "./AccountSettingOrders.vue?vue&type=template&id=be1927d0&"
import script from "./AccountSettingOrders.vue?vue&type=script&lang=js&"
export * from "./AccountSettingOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports